module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/privacy-policy.json
// module id = 1787
// module chunks = 231881910887020